// packages import
import React, {Component} from 'react';
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';
// import styles
import './Coupons.css';

// import components
import CommunitySidePane from '../CommunitySidePane';
import {DocumentTitle, EmptyMessage, Spinner, PrimaryButton} from '../../widgets';
import CouponCard from './coupon-card/CouponCard';
import CommunityPage from '../CommunityPage';

// import actions
import {uiActions} from '../../chrome';
import actions from './coupons.actions';
import confirmActions from '../../widgets/confirmation.actions';
import {retrieveCommunity} from '../community.actions';

// import selectors
import {
	getSessionUserMembership,
	canAdmin,
	getParamsUniqueName,
	checkAdmin
} from '../community.selectors';
import {session} from 'passport';

class Coupons extends CommunityPage {
	constructor(props) {
		super(props);

		const currentUrl = this.props.location.pathname;
		const urlComponents = currentUrl.split('/');

		// load current community if not already loaded
		this.props.retrieveCommunity(urlComponents[urlComponents.length - 1]);

		// uncomment code if coupons page in community can not be directly accessed by pasting the url in browser
		/* const paramUniqueName = getParamsUniqueName(this.props);

		// if community is not loaded then load it before fetching other data
		if (!this.props.community) {
			this.props.retrieveCommunity(paramUniqueName);
		} */
	}

	/**
	 * componentDidMount life cycle hook
	 */
	componentDidMount() {
		if (this.props.community && !this.props.community.subscription) {
			this.props.errorMessage(
				'this community has not enabled promotions feature yet. If you are a member, Please contact community admin to request access to the feature.'
			);
			this.props.history.goBack();
		}

		if (this.props.community) {
			this.props.fetchApprovedCoupons(this.props.community.uuid);
			this.props.fetchCouponsPendingApproval(this.props.community.uuid);
		}
	}

	componentWillReceiveProps(nextProps) {
		// listen to props change when community is loaded and fetch coupons
		if (!this.props.community && nextProps.community) {
			this.props.fetchApprovedCoupons(nextProps.community.uuid);
			this.props.fetchCouponsPendingApproval(nextProps.community.uuid);
		}
	}

	/**
	 * Approve coupon handler - called when Approve button is clicked by admin
	 * @param {*} couponUuid
	 */
	approveCoupon = couponUuid => {
		this.props.approveCoupon(couponUuid);
	};

	/**
	 * Reject coupon handler - called when Reject button is clicked by admin
	 * @param {*} couponUuid
	 */
	rejectCoupon = couponUuid => {
		this.props.rejectCoupon(couponUuid);
	};

	/**
	 * Function to check if coupon can be redeemed by current user/provider
	 * (provider can not redeem own coupons)
	 * @param {*} coupon
	 */
	canRedeemCoupon = coupon => {
		let currentProvier = '';

		if (this.props.session && this.props.session.current && this.props.session.current.provider) {
			currentProvier = this.props.session.current.provider;
		}

		return currentProvier.uuid !== coupon.created_by.uuid && coupon.redeemed === false;
	};

	/**
	 * Function to check if user is logged in or not
	 * @returns
	 */
	isLoggedIn = () => {
		if (this.props.session && this.props.session.current) {
			return true;
		} else {
			false;
		}
	};

	render() {
		const {
			sessionProvider,
			editContacts,
			retrieveCommunity,
			community,
			add_coupon,
			session,
			coupon,
			screenSize
		} = this.props;

		let isAddCouponBtnVisible = false;

		const isAdmin = checkAdmin(this.props);
		const sessionUserMembership = getSessionUserMembership(this.props);

		if (sessionUserMembership && sessionUserMembership.status === 'approved') {
			isAddCouponBtnVisible = true;
		}

		return (
			<DocumentTitle title="b2me">
				{community && (
					<main className="CommunityNoticesPage">
						<CommunitySidePane
							community={community}
							sessionProvider={sessionProvider}
							showAbout={false}
							showAddCouponButton={isAddCouponBtnVisible}
							addingCoupon={() => add_coupon(session.current.provider.uuid, community.uuid)}
							editContacts={editContacts}
						/>

						<section className="CouponsList">
							{isAdmin &&
							coupon &&
							coupon.couponsPendingApproval &&
							coupon.couponsPendingApproval.length ? (
								<div>
									<h3 className="PromotionsTitle">Promotions Pending Approval</h3>
									<div className="coupons">
										{coupon.couponsPendingApproval.map(coupon => (
											<CouponCard
												key={coupon.uuid}
												screenSize={screenSize}
												size="small"
												avatarImage={coupon.created_by.profile.avatarImage}
												firstname={coupon.created_by.user.firstname}
												lastname={coupon.created_by.user.lastname}
												businessName={coupon.created_by.user.businessName}
												couponUuid={coupon.uuid}
												productLink={coupon.productLink}
												code={coupon.code}
												description={coupon.description}
												expiryDate={coupon.expiryDate}
												showActions={true}
												showOptions={isAdmin}
												canRedeem={false}
												coupon={coupon}
												providerProfileLink={'/@' + coupon.created_by.profile.uniqueName}
												showCommunityName={false}
												onApprove={() => this.approveCoupon(coupon.uuid)}
												onReject={() => this.rejectCoupon(coupon.uuid)}
												options={[
													{
														key: 'header',
														icon: 'icon icon-delete',
														label: 'Remove this coupon',
														onSelect: e => {
															e.stopPropagation();
															this.props.confirmRemoval(coupon.uuid, 'UNAPPROVED');
														}
													},
													{
														key: 'edit-coupon',
														icon: 'icon icon-mode_edit',
														label: 'Edit this coupon',
														onSelect: e => {
															e.stopPropagation();
															this.props.editCoupon(coupon, 'COMMUNITY_PENDING_APPROVAL_COUPONS');
														}
													}
												]}
											/>
										))}
									</div>
								</div>
							) : null}

							<h3 className="PromotionsTitle">Promotions</h3>
							<div className="coupons">
								{coupon && coupon.communityCoupons && coupon.communityCoupons.length ? (
									coupon.communityCoupons.map(coupon => (
										<CouponCard
											key={coupon.uuid}
											screenSize={screenSize}
											size="small"
											avatarImage={coupon.created_by.profile.avatarImage}
											firstname={coupon.created_by.user.firstname}
											lastname={coupon.created_by.user.lastname}
											businessName={coupon.created_by.user.businessName}
											couponUuid={coupon.uuid}
											code={coupon.code}
											productLink={coupon.productLink}
											description={coupon.description}
											expiryDate={coupon.expiryDate}
											showActions={false}
											showOptions={isAdmin}
											showCommunityName={false}
											canRedeem={true && this.isLoggedIn()}
											coupon={coupon}
											providerProfileLink={'/@' + coupon.created_by.profile.uniqueName}
											redeemDisabled={!this.canRedeemCoupon(coupon)}
											isBeingRedeemed={coupon.isBeingRedeemed}
											options={[
												{
													key: 'remove-coupon',
													icon: 'icon icon-delete',
													label: 'Remove this coupon',
													onSelect: e => {
														e.stopPropagation();
														this.props.confirmRemoval(coupon.uuid, 'APPROVED');
													}
												},
												{
													key: 'edit-coupon',
													icon: 'icon icon-mode_edit',
													label: 'Edit this coupon',
													onSelect: e => {
														e.stopPropagation();
														this.props.editCoupon(coupon, 'COMMUNITY_APPROVED_COUPONS');
													}
												}
											]}
										/>
									))
								) : (
									<EmptyMessage>
										There are no active promotions available for this community.
									</EmptyMessage>
								)}
							</div>
						</section>
					</main>
				)}
			</DocumentTitle>
		);
	}
}

const mapStateToProps = state => {
	return {
		community: state.community,
		session: state.session,
		coupon: state.coupon,
		screenSize: state.ui.screenSize,
		sessionProvider: state.session && state.session.current
	};
};

const mapDispatchToProps = dispatch => {
	return {
		add_coupon: (userUuid, communityUuid) => {
			dispatch(actions.couponAdding({userUuid: userUuid, communityUuid: communityUuid}));
			dispatch(uiActions.uiModal('add-coupon'));
		},
		fetchApprovedCoupons: communityUuid =>
			dispatch(actions.fetchApprovedCoupons({communityUuid: communityUuid})),
		fetchCouponsPendingApproval: communityUuid =>
			dispatch(actions.fetchCouponsPendingApproval({communityUuid: communityUuid})),
		rejectCoupon: couponUuid => dispatch(actions.rejectCoupon(couponUuid)),
		approveCoupon: couponUuid => dispatch(actions.approveCoupon(couponUuid)),
		retrieveCommunity: uniqueName => dispatch(retrieveCommunity(uniqueName)),
		confirmRemoval: (couponUuid, couponStatus) =>
			dispatch(
				confirmActions.open({
					title: `Do you really want to remove this Coupon?`,
					message: 'The coupon will no longer be displayed on community profile. Are you sure?',
					onConfirm: () => dispatch(actions.deleteCoupon(couponUuid, couponStatus))
				})
			),
		editCoupon: (coupon, section) => {
			dispatch(actions.editCoupon(coupon, section));
		},
		errorMessage: message => {
			dispatch(uiActions.uiMessage(message));
		}
	};
};

export default withRouter(
	connect(
		mapStateToProps,
		mapDispatchToProps
	)(Coupons)
);



// WEBPACK FOOTER //
// ./src/community/coupons/Coupons.js